import TableStructure from 'common/TableStructure';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import React from 'react';

export const GridContainer = styled.div`
    width: 100%;
    overflow-x: auto;

    @media (min-width: 768px) {
        overflow-x: visible;
    }
`;

const DAY_BY_INDEX = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const formatDay = (day) => {
    if (day === null || day === undefined || day === '') return '-';
    if (typeof day === 'number') return DAY_BY_INDEX[day] || '-';
    const numeric = Number(day);
    if (!Number.isNaN(numeric) && DAY_BY_INDEX[numeric]) return DAY_BY_INDEX[numeric];
    return String(day);
};

const formatTime = (value) => {
    if (!value) return '-';
    if (typeof value === 'string' && /^\d{2}:\d{2}/.test(value)) {
        const parsed = dayjs(`2000-01-01T${value.slice(0, 5)}`);
        if (parsed.isValid()) return parsed.format('h:mm A');
    }
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('h:mm A') : String(value);
};

const formatVisitMode = (row) => {
    if (row?.visit_mode) {
        if (row.visit_mode === 'both') return 'In-Person & Telemedicine';
        if (row.visit_mode === 'in_person') return 'In-Person Only';
        if (row.visit_mode === 'telemedicine') return 'Telemedicine Only';
        return row.visit_mode;
    }
    const isInPerson = row?.is_inperson === true || row?.is_inperson === '1' || row?.is_inperson === 1;
    const isTele = row?.is_telemedicine === true || row?.is_telemedicine === '1' || row?.is_telemedicine === 1;
    if (isInPerson && isTele) return 'In-Person & Telemedicine';
    if (isTele) return 'Telemedicine Only';
    return 'In-Person Only';
};

const columns = () => [
    {
        field: 'id',
        headerName: <FormattedMessage id="be.seen.availability.table.id" defaultMessage="ID" />,
        flex: 0.3,
        minWidth: 60,
    },
    {
        field: 'day',
        headerName: <FormattedMessage id="be.seen.availability.table.day" defaultMessage="Day" />,
        flex: 1,
        minWidth: 120,
        renderCell: (params) => formatDay(params.row.day),
    },
    {
        field: 'start_time',
        headerName: <FormattedMessage id="be.seen.availability.table.start" defaultMessage="Start Time" />,
        flex: 1,
        minWidth: 120,
        renderCell: (params) => formatTime(params.row.start_time || params.row.start_datetime),
    },
    {
        field: 'end_time',
        headerName: <FormattedMessage id="be.seen.availability.table.end" defaultMessage="End Time" />,
        flex: 1,
        minWidth: 120,
        renderCell: (params) => formatTime(params.row.end_time || params.row.end_datetime),
    },
    {
        field: 'visit_mode',
        headerName: <FormattedMessage id="be.seen.availability.table.mode" defaultMessage="Visit Mode" />,
        flex: 1.2,
        minWidth: 150,
        renderCell: (params) => formatVisitMode(params.row),
    },
    {
        field: '',
        headerName: '',
        sortable: false,
        flex: 0.3,
        minWidth: 50,
        renderCell: () => {
            return (
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: '12px',
                    }}
                >
                    <path
                        d="M9 18L15 12L9 6"
                        stroke="#666666"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        },
    },
];

export default function AvailabilityTable({ rows, togglePopup }) {
    return (
        <GridContainer>
            <TableStructure rows={rows} columns={columns()} handleRowClick={togglePopup} />
        </GridContainer>
    );
}
